import { ErrorSummary } from '@digdir/designsystemet-react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { useOppvarmingFormContext } from '../../../utils';
import { ErrorGroupWrapper } from '../../formErrors/styledComponents';
import { ErrorLinkItem } from '../../formErrors/errorLinkItem';

// Ved errors consists of four categories -  the main category Ved, with three subgroups: "Åpen peis", "Lukket ovn" and
// "Peis med dør".
export const VedErrorSummary = () => {
  const { formState } = useOppvarmingFormContext();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming.ved' });

  const errors = formState.errors.ved;

  const vedSelectedError = errors?.value?.apenPeis?.selected;

  const apenPeisError = errors?.value?.apenPeis?.value?.installasjonsAr;
  const peisMedDorError = errors?.value?.peisMedDor?.value?.installasjonsAr;
  const lukketOvnError = errors?.value?.lukketOvn?.value?.installasjonsAr;

  if (!errors) {
    return null;
  }

  return (
    <Fragment>
      {vedSelectedError && (
        <ErrorGroupWrapper>
          <ErrorSummary.Heading>{t('label')}</ErrorSummary.Heading>
          <ErrorSummary.List>
            <ErrorLinkItem error={vedSelectedError} />
          </ErrorSummary.List>
        </ErrorGroupWrapper>
      )}
      {apenPeisError && (
        <ErrorGroupWrapper>
          <ErrorSummary.Heading>{t('apenPeis.label')}</ErrorSummary.Heading>
          <ErrorSummary.List>
            <ErrorLinkItem error={apenPeisError} />
            <ErrorLinkItem error={errors?.value?.apenPeis?.value?.vetInstallasjonsAr} />
          </ErrorSummary.List>
        </ErrorGroupWrapper>
      )}
      {lukketOvnError && (
        <ErrorGroupWrapper>
          <ErrorSummary.Heading>{t('lukketOvn.label')}</ErrorSummary.Heading>
          <ErrorSummary.List>
            <ErrorLinkItem error={lukketOvnError} />
            <ErrorLinkItem error={errors?.value?.lukketOvn?.value?.vetInstallasjonsAr} />
          </ErrorSummary.List>
        </ErrorGroupWrapper>
      )}

      {peisMedDorError && (
        <ErrorGroupWrapper>
          <ErrorSummary.Heading>{t('peisMedDor.label')}</ErrorSummary.Heading>
          <ErrorSummary.List>
            <ErrorLinkItem error={peisMedDorError} />
            <ErrorLinkItem error={errors?.value?.peisMedDor?.value?.vetInstallasjonsAr} />
          </ErrorSummary.List>
        </ErrorGroupWrapper>
      )}
    </Fragment>
  );
};
